import type { BettingInformation } from '../../../Model/BettingInformation'
import type { IObservableStarter } from '../../../Model/Observables/IObservableStarter'
import type { ICheckBoxPipelineProcessor } from './ICheckBoxPipelineProcessor'
import type { ICheckBoxSelectionPipeline } from './ICheckBoxSelectionPipeline'
import type { ISelectionContext } from './ISelectionContext'

export default class CheckBoxSelectionPipeline implements ICheckBoxSelectionPipeline {
  constructor(private processor: ICheckBoxPipelineProcessor) {}

  process(
    current: IObservableStarter,
    all: ko.ObservableArray<IObservableStarter>,
    context: BettingInformation,
    selectionContext: ISelectionContext,
    count: number
  ): IObservableStarter[] {
    return this.processor.process(current, all, context, selectionContext, count)
  }
}
